import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueToast from 'vue-toast-notification'
import VueTheMask from 'vue-the-mask'
import VueMask from 'v-mask'

import 'vue-toast-notification/dist/theme-sugar.css'
import './design/index.scss'

Vue.config.productionTip = false

Vue.use(VueToast, {
  position: 'top-right',
  duration: 4000,
})
Vue.use(VueTheMask)
Vue.use(VueMask)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
